// extracted by mini-css-extract-plugin
export default {"card":"AuthModal_card__l8NT5"};